document.addEventListener("DOMContentLoaded", function () {
  const footerReveal = document.querySelector(".footer--reveal");
  const footerMain = document.querySelector(".footer--main");
  let footerRevealHeight = 0;

  function updateFooterHeight() {
    if (footerReveal) {
      footerRevealHeight = footerReveal.offsetHeight;
      document.documentElement.style.setProperty(
        "--reveal-footer-height",
        `${footerRevealHeight}px`
      );
    }
  }

  // Initial calculation
  updateFooterHeight();

  // Handle footer visibility on scroll and resize
  if (footerMain && footerReveal) {
    function updateFooterVisibility() {
      // Check if we're near the bottom of the page
      const isNearBottom =
        window.scrollY + window.innerHeight >
        document.body.offsetHeight - footerRevealHeight;

      // Toggle footer visibility
      if (isNearBottom) {
        footerReveal.style.opacity = "1";
        footerReveal.style.pointerEvents = "auto";
      } else {
        footerReveal.style.opacity = "0";
        footerReveal.style.pointerEvents = "none";
      }
    }

    // Initial check
    updateFooterVisibility();

    // Update on scroll and resize
    window.addEventListener("scroll", updateFooterVisibility);
    window.addEventListener("resize", function () {
      updateFooterHeight();
      updateFooterVisibility();
    });
  }
});
